import React from "react";

export const Message = ({ message }) => {
    const {
        messagePartOne,
        linkhref,
        linkLabel,
        messagePartTwo
    } = parseMessage(message);

    return (
        <>
            {messagePartOne}
            <a href={linkhref}>{linkLabel}</a>
            {messagePartTwo}
        </>
    );
};

function parseMessage(message) {
    const linkLabel = message.substring(
        message.indexOf("[") + 1,
        message.indexOf("]")
    );
    const linkhref = message.substring(
        message.indexOf("(") + 1,
        message.indexOf(")")
    );
    const messagePartOne = message.substring(0, message.indexOf("["));
    const messagePartTwo = message.substring(
        message.indexOf(")") + 1,
        message.length
    );
    return {
        messagePartOne,
        linkhref,
        linkLabel,
        messagePartTwo
    };
}
